import { render, staticRenderFns } from "./SrPlanEdit.vue?vue&type=template&id=becd977c&"
import script from "./SrPlanEdit.vue?vue&type=script&lang=js&"
export * from "./SrPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports